module.exports = __webpack_public_path__ + "static/media/founder.81ca4fb0.png";